const $9d07393aaa24a623$export$63c0fd2415399f0d = (dx, dy)=>{
    const angleInRadians = Math.atan2(dy, dx);
    if (angleInRadians < -2.74 || angleInRadians > 2.74) return 6;
    if (angleInRadians < -1.96) return 7;
    if (angleInRadians < -1.17) return 0;
    if (angleInRadians < -0.39) return 1;
    if (angleInRadians < 0.39) return 2;
    if (angleInRadians < 1.17) return 3;
    if (angleInRadians < 1.96) return 4;
    if (angleInRadians < 2.74) return 5;
};


class $0017c5d798155445$export$2616165974278734 {
    constructor(game){
        this.game = game;
        this.image = document.getElementById("bull");
        this.collisionX = game.mouse.posX;
        this.collisionY = game.mouse.posY;
        this.collisionRadius = 30;
        this.dx = 0;
        this.dy = 0;
        this.speedX = 0;
        this.speedY = 0;
        this.speedModifier = 5;
        this.playerWidth = 255;
        this.playerheight = 256;
        this.width = this.playerWidth;
        this.height = this.playerheight;
        this.spriteX;
        this.spriteY;
        this.frameX = 0;
        this.frameY = 0;
    }
    draw(context) {
        context.drawImage(this.image, this.frameX * this.playerWidth, this.frameY * this.playerheight, this.playerWidth, this.playerheight, this.spriteX, this.spriteY, this.width, this.height);
        if (this.game.debug) {
            context.beginPath();
            context.arc(this.collisionX, this.collisionY, this.collisionRadius, 0, Math.PI * 2);
            context.save();
            context.globalAlpha = 0.5;
            context.fill();
            context.restore();
            context.moveTo(this.game.mouse.posX, this.game.mouse.posY);
            context.lineTo(this.collisionX, this.collisionY);
            context.stroke();
        }
    }
    update() {
        this.dx = this.game.mouse.posX - this.collisionX;
        this.dy = this.game.mouse.posY - this.collisionY;
        this.frameY = (0, $9d07393aaa24a623$export$63c0fd2415399f0d)(this.dx, this.dy);
        const distance = Math.hypot(this.dx, this.dy);
        if (distance > this.speedModifier) {
            this.speedX = this.dx / distance || 0;
            this.speedY = this.dy / distance || 0;
        } else {
            this.speedX = 0;
            this.speedY = 0;
        }
        this.collisionX += this.speedX * this.speedModifier;
        this.collisionY += this.speedY * this.speedModifier;
        /**
     * Horizontal boundary
     */ if (this.collisionX < this.collisionRadius) this.collisionX = this.collisionRadius;
        else if (this.collisionX > this.game.width - this.collisionRadius) this.collisionX = this.game.width() - this.collisionRadius;
        /**
     * Vertical boundary
     */ if (this.collisionY < this.game.topMargin + this.collisionRadius) this.collisionY = this.game.topMargin + this.collisionRadius;
        else if (this.collisionY > this.game.height - this.collisionRadius) this.collisionY = this.game.height() - this.collisionRadius;
        this.spriteX = this.collisionX - this.width * 0.5;
        this.spriteY = this.collisionY - this.height * 0.5 - 80;
        this.game.obstacles.forEach((obstacle)=>{
            const { collision: collision, distance: distance, sumOfRadii: sumOfRadii, dx: dx, dy: dy } = this.game.checkCollision(this, obstacle);
            if (collision) {
                const unitX = dx / distance;
                const unitY = dy / distance;
                this.collisionX = obstacle.collisionX + (sumOfRadii + 1) * unitX;
                this.collisionY = obstacle.collisionY + (sumOfRadii + 1) * unitY;
            }
        });
    }
}


class $64c0ae715ddfc4e3$var$Obstacle {
    constructor(game, position){
        this.game = game;
        this.image = document.getElementById("obstacles");
        this.collisionX = position.posX;
        this.collisionY = position.posY;
        this.obstacleWidth = 250;
        this.obstacleHeight = 250;
        this.width = this.obstacleWidth;
        this.height = this.obstacleHeight;
        this.spriteX = this.collisionX - this.width * 0.5;
        this.spriteY = this.collisionY - this.width * 0.5 - 80;
        this.frameX = Math.floor(Math.random() * 4);
        this.frameY = Math.floor(Math.random() * 3);
        this.collisionRadius = this.game.collisionRadius;
    }
    draw(context) {
        context.drawImage(this.image, this.frameX * this.obstacleWidth, this.frameY * this.obstacleHeight, this.obstacleWidth, this.obstacleHeight, this.spriteX, this.spriteY, this.width, this.height);
        if (this.game.debug) {
            context.beginPath();
            context.arc(this.collisionX, this.collisionY, this.collisionRadius, 0, Math.PI * 2);
            context.save();
            context.globalAlpha = 0.5;
            context.fill();
            context.restore();
            context.stroke();
        }
    }
    update() {}
}
var $64c0ae715ddfc4e3$export$2e2bcd8739ae039 = $64c0ae715ddfc4e3$var$Obstacle;


class $3b186e545e47b541$var$Larva {
    constructor(game, posX, posY){
        this.game = game;
        this.image = document.getElementById("larva");
        this.collisionRadius = 30;
        this.speedY = Math.random() + 1;
        this.spriteWidth = 150;
        this.spriteHeight = 150;
        this.width = this.spriteWidth;
        this.height = this.spriteHeight;
        this.collisionX = posX;
        this.collisionY = posY;
        this.spriteX = this.collisionX - this.width * 0.5;
        this.spriteY = this.collisionY - this.height * 0.5 - 30;
        this.frameX = 0;
        this.frameY = Math.floor(Math.random() * 2);
        this.markedForDeletion = false;
    }
    draw(context) {
        context.drawImage(this.image, this.frameX * this.spriteWidth, this.frameY * this.spriteHeight, this.spriteWidth, this.spriteHeight, this.spriteX, this.spriteY, this.spriteWidth, this.spriteHeight);
        if (this.game.debug) {
            context.beginPath();
            context.arc(this.collisionX, this.collisionY, this.collisionRadius, 0, Math.PI * 2);
            context.save();
            context.globalAlpha = 0.5;
            context.fill();
            context.restore();
            context.stroke();
        }
    }
    update() {
        this.spriteX = this.collisionX - this.width * 0.5;
        this.spriteY = this.collisionY - this.height * 0.5 - 40;
        this.collisionY -= this.speedY;
        /**
     *  Check and remove #Larva when moves to safety
     */ if (this.spriteY + (this.height - this.game.topMargin) < 0) {
            this.markedForDeletion = true;
            this.game.removeGameObjects();
            if (!this.game.over) this.game.score++;
        }
        /**
     *  Movement physics for #Larva on collision with #Player & #Obstacles
     */ const collisionObjects = [
            ...this.game.obstacles,
            this.game.player
        ];
        collisionObjects.forEach((object)=>{
            const { collision: collision, distance: distance, sumOfRadii: sumOfRadii, dx: dx, dy: dy } = this.game.checkCollision(this, object);
            if (collision) {
                const unitX = dx / distance;
                const unitY = dy / distance;
                this.collisionX = object.collisionX + (sumOfRadii + 1) * unitX;
                this.collisionY = object.collisionY + (sumOfRadii + 1) * unitY;
            }
        });
        /**
     *  Movement physics for #Larva on collision with #Toads
     */ const collisionEnemies = [
            ...this.game.toads
        ];
        collisionEnemies.forEach((object)=>{
            const { collision: collision } = this.game.checkCollision(this, object);
            if (collision) {
                this.markedForDeletion = true;
                this.game.removeGameObjects();
                this.game.lostHatchlings++;
            }
        });
    }
}
var $3b186e545e47b541$export$2e2bcd8739ae039 = $3b186e545e47b541$var$Larva;


class $82a7e179f894b03b$var$Egg {
    constructor(game){
        this.game = game;
        this.image = document.getElementById("egg");
        this.collisionRadius = 30;
        this.margin = this.collisionRadius * 2;
        this.collisionX = this.margin + Math.random() * (this.game.width() - this.margin * 2);
        this.collisionY = this.game.topMargin + Math.random() * (this.game.height() - this.game.topMargin - this.margin);
        this.spriteWidth = 110;
        this.spriteHeight = 135;
        this.width = this.spriteWidth;
        this.height = this.spriteHeight;
        this.spriteX;
        this.spriteY;
        this.hatchTimer = 0;
        this.hatchInterval = 10000;
        this.markedForDeletion = false;
    }
    draw(context) {
        context.drawImage(this.image, this.spriteX, this.spriteY);
        if (this.game.debug) {
            context.beginPath();
            context.arc(this.collisionX, this.collisionY, this.collisionRadius, 0, Math.PI * 2);
            context.save();
            context.globalAlpha = 0.5;
            context.fill();
            context.restore();
            context.stroke();
            const displayTime = (this.hatchTimer * 0.001).toFixed(0);
            context.fillText(displayTime, this.collisionX, this.collisionY - this.collisionRadius * 2.5);
        }
    }
    update(deltaTime) {
        this.spriteX = this.collisionX - this.width * 0.5;
        this.spriteY = this.collisionY - this.height * 0.5 - 30;
        const collisionObjects = [
            ...this.game.obstacles,
            ...this.game.toads,
            ...this.game.hatchlings,
            this.game.player
        ];
        collisionObjects.forEach((obstacle)=>{
            const { collision: collision, distance: distance, sumOfRadii: sumOfRadii, dx: dx, dy: dy } = this.game.checkCollision(this, obstacle);
            if (collision) {
                const unitX = dx / distance;
                const unitY = dy / distance;
                this.collisionX = obstacle.collisionX + (sumOfRadii + 1) * unitX;
                this.collisionY = obstacle.collisionY + (sumOfRadii + 1) * unitY;
            }
        });
        if ((this.hatchTimer > this.hatchInterval || this.collisionY < this.game.topMargin) && !this.game.over) {
            this.game.hatchlings.push(new (0, $3b186e545e47b541$export$2e2bcd8739ae039)(this.game, this.collisionX, this.collisionY));
            this.markedForDeletion = true;
            this.game.removeGameObjects();
        } else this.hatchTimer += deltaTime;
    }
}
var $82a7e179f894b03b$export$2e2bcd8739ae039 = $82a7e179f894b03b$var$Egg;


class $dcb2be3ebd4ef55d$var$Toad {
    constructor(game){
        this.game = game;
        this.image = document.getElementById("toad");
        this.collisionRadius = 30;
        this.speedX = Math.random() * 3 + 0.5;
        this.margin = this.collisionRadius * 2;
        this.spriteWidth = 140;
        this.spriteHeight = 260;
        this.width = this.spriteWidth;
        this.height = this.spriteHeight;
        this.collisionX = this.game.width() + this.width + Math.random() * this.game.width() * 0.5;
        this.collisionY = this.game.topMargin + Math.random() * (this.game.height() - this.game.topMargin - this.margin);
        this.spriteX = this.collisionX - this.width * 0.5;
        this.spriteY = this.collisionY - this.height * 0.5 - 30;
        this.frameX = 0;
        this.frameY = Math.floor(Math.random() * 4);
    }
    draw(context) {
        context.drawImage(this.image, this.frameX * this.spriteWidth, this.frameY * this.spriteHeight, this.spriteWidth, this.spriteHeight, this.spriteX, this.spriteY, this.spriteWidth, this.spriteHeight);
        if (this.game.debug) {
            context.beginPath();
            context.arc(this.collisionX, this.collisionY, this.collisionRadius, 0, Math.PI * 2);
            context.save();
            context.globalAlpha = 0.5;
            context.fill();
            context.restore();
            context.stroke();
        }
    }
    update() {
        this.spriteX = this.collisionX - this.width * 0.5;
        this.spriteY = this.collisionY - this.height * 0.5 - 60;
        this.collisionX -= this.speedX;
        if (this.spriteX + this.width < 0 && !this.game.over) {
            this.collisionX = this.game.width + this.width + Math.random() * this.game.width * 0.5;
            this.collisionY = this.game.topMargin + Math.random() * (this.game.height - this.game.topMargin - this.margin);
            this.frameY = Math.floor(Math.random() * 4);
        }
        const collisionObjects = [
            ...this.game.obstacles,
            this.game.player
        ];
        collisionObjects.forEach((obstacle)=>{
            const { collision: collision, distance: distance, sumOfRadii: sumOfRadii, dx: dx, dy: dy } = this.game.checkCollision(this, obstacle);
            if (collision) {
                const unitX = dx / distance;
                const unitY = dy / distance;
                this.collisionX = obstacle.collisionX + (sumOfRadii + 1) * unitX;
                this.collisionY = obstacle.collisionY + (sumOfRadii + 1) * unitY;
            }
        });
    }
}
var $dcb2be3ebd4ef55d$export$2e2bcd8739ae039 = $dcb2be3ebd4ef55d$var$Toad;


const $7fee6969fa349124$export$b11bd9a0808bdc9 = ({ context: context, content: content, posX: posX, posY: posY, align: align, fontStyle: fontStyle })=>{
    context.font = fontStyle;
    context.textAlign = align;
    context.fillText(content, posX, posY);
};


/**
 *  Minimum required score for victory
 */ const $9d53a1b897a67ad9$export$6caa59613a7f1d16 = 30;
const $9d53a1b897a67ad9$export$bd8c95b582384de5 = 15;


const $384a512539b7cccf$export$6e76c1248b602b23 = ({ gameWidth: gameWidth, gameHeight: gameHeight, verticalMargin: verticalMargin = 0, horizontalMargin: horizontalMargin = 0, size: size, count: count, distanceBuffer: distanceBuffer = 0 })=>{
    let positions = [];
    for(let attemps = 0; attemps < 500 && count > 0; attemps++){
        const posX = Math.random() * gameWidth;
        const posY = Math.random() * gameHeight;
        let hasOverlap = false;
        for(let posIndex = 0; posIndex < positions.length; posIndex++){
            const prevObstacle = positions[posIndex];
            const dx = prevObstacle.posX - posX;
            const dy = prevObstacle.posY - posY;
            const distance = Math.hypot(dy, dx);
            if (distance < Math.max(size * 2, distanceBuffer)) {
                hasOverlap = true;
                break;
            }
        }
        if (!hasOverlap && posX > horizontalMargin + size * 2 && posY > verticalMargin + size * 2 && posX < gameWidth - size && posY < gameHeight) {
            positions.push({
                posX: posX,
                posY: posY
            });
            count--;
        }
    }
    return positions;
};
const $384a512539b7cccf$export$9f1c65284a10fd65 = ({ score: score = 0, lostHatchlings: lostHatchlings = 0 })=>{
    return score >= (0, $9d53a1b897a67ad9$export$6caa59613a7f1d16) || lostHatchlings >= (0, $9d53a1b897a67ad9$export$bd8c95b582384de5);
};
const $384a512539b7cccf$export$97f8cbad1fae839b = ({ score: score = 0, lostHatchlings: lostHatchlings })=>{
    const restartText = "Press 'R' to restart the game";
    if (score >= (0, $9d53a1b897a67ad9$export$6caa59613a7f1d16)) return {
        title: "AWESOME!!!",
        description: `You nailed it with ${score} points!`,
        restartText: restartText
    };
    if (score >= Math.floor((0, $9d53a1b897a67ad9$export$6caa59613a7f1d16) * 0.9)) return {
        title: "SO CLOSE!!!",
        description: `Almost there with ${score} points!`,
        restartText: restartText
    };
    return {
        title: "OOPS!!!",
        description: `You lost ${lostHatchlings} hatchlings!`,
        restartText: restartText
    };
};


class $55b76b594f4baf04$export$985739bfa5723e08 {
    constructor(canvas){
        this.canvas = canvas;
        this.width = ()=>this.canvas.width;
        this.height = ()=>this.canvas.height; // Use as function for always-up-to-date values
        this.debug = false;
        this.topMargin = Math.floor(this.height() * 0.5); // Responsive top margin
        this.obstaclesCount = 5;
        this.collisionRadius = 60;
        this.obstacleMinSpacing = 200;
        this.obstacles = [];
        this.eggs = [];
        this.toads = [];
        this.hatchlings = [];
        this.eggTimer = 0;
        this.eggInterval = 1000;
        this.eggCountMax = 10;
        this.toadCountMax = 5;
        this.lostHatchlings = 0;
        this.score = 0;
        this.over = false;
        this.mouse = {
            posX: this.width() * 0.5,
            posY: this.height() * 0.5,
            pressed: false
        };
        this.player = new (0, $0017c5d798155445$export$2616165974278734)(this);
        canvas.addEventListener("mousedown", (e)=>{
            this.mouse.posX = e.offsetX;
            this.mouse.posY = e.offsetY;
            this.mouse.pressed = true;
        });
        canvas.addEventListener("mousemove", (e)=>{
            if (this.mouse.pressed) {
                this.mouse.posX = e.offsetX;
                this.mouse.posY = e.offsetY;
            }
        });
        canvas.addEventListener("mouseup", (e)=>{
            this.mouse.posX = e.offsetX;
            this.mouse.posY = e.offsetY;
            this.mouse.pressed = false;
        });
        window.addEventListener("keydown", (e)=>{
            if (e.key === "d") this.debug = !this.debug;
            if (e.key === "r" || e.key === "R") this.restart();
        });
    }
    init() {
        this.topMargin = Math.floor(this.height() * 0.35);
        const obstaclesPositions = (0, $384a512539b7cccf$export$6e76c1248b602b23)({
            gameWidth: this.width(),
            gameHeight: this.height(),
            verticalMargin: this.topMargin,
            size: this.collisionRadius,
            count: this.obstaclesCount,
            distanceBuffer: this.obstacleMinSpacing
        });
        obstaclesPositions.forEach((position)=>{
            this.obstacles.push(new (0, $64c0ae715ddfc4e3$export$2e2bcd8739ae039)(this, position));
        });
        this.addToads();
    }
    addEgg() {
        this.eggs.push(new (0, $82a7e179f894b03b$export$2e2bcd8739ae039)(this));
    }
    addToads() {
        for(let count = 0; count < this.toadCountMax; count++)this.toads.push(new (0, $dcb2be3ebd4ef55d$export$2e2bcd8739ae039)(this));
    }
    removeGameObjects() {
        this.eggs = this.eggs.filter((egg)=>!egg.markedForDeletion);
        this.hatchlings = this.hatchlings.filter((hatchling)=>!hatchling.markedForDeletion);
    }
    checkCollision(objectA, objectB) {
        const dx = objectA.collisionX - objectB.collisionX;
        const dy = objectA.collisionY - objectB.collisionY;
        const distance = Math.hypot(dy, dx);
        const sumOfRadii = objectA.collisionRadius + objectB.collisionRadius;
        return {
            collision: distance < sumOfRadii,
            distance: distance,
            sumOfRadii: sumOfRadii,
            dx: dx,
            dy: dy
        };
    }
    render(context, deltaTime) {
        const gameObjects = [
            ...this.obstacles,
            ...this.eggs,
            ...this.toads,
            ...this.hatchlings,
            this.player
        ];
        /**
     *  Orders the rendering of objects based on Y-axis to provide pseudo 3D effect
     */ gameObjects.sort((objectA, objectB)=>objectA.collisionY - objectB.collisionY);
        gameObjects.forEach((object)=>{
            object.draw(context);
            object.update(deltaTime);
        });
        if (this.eggTimer > this.eggInterval && this.eggs.length < this.eggCountMax && !this.over) {
            this.addEgg();
            this.eggTimer = 0;
        } else this.eggTimer += deltaTime;
        context.save();
        context.textAlign = "left";
        context.fillText(`Score: ${this.score}`, 25, 50);
        if (this.debug) context.fillText(`Lost: ${this.lostHatchlings}`, 25, 100);
        context.restore();
        if ((0, $384a512539b7cccf$export$9f1c65284a10fd65)({
            score: this.score,
            lostHatchlings: this.lostHatchlings
        })) {
            this.over = true;
            context.save();
            context.fillStyle = "rgba(0,0,0,0.5)";
            context.fillRect(0, 0, this.width(), this.height());
            context.shadowColor = "black";
            context.shadowOffsetX = 4;
            context.shadowOffsetY = 4;
            context.fillStyle = "white";
            context.textAlign = "center";
            const { title: title, description: description, restartText: restartText } = (0, $384a512539b7cccf$export$97f8cbad1fae839b)({
                score: this.score,
                lostHatchlings: this.lostHatchlings
            });
            (0, $7fee6969fa349124$export$b11bd9a0808bdc9)({
                context: context,
                content: title,
                posX: this.width() * 0.5,
                posY: this.height() * 0.4,
                align: "center",
                fontStyle: "130px Hevetica"
            });
            (0, $7fee6969fa349124$export$b11bd9a0808bdc9)({
                context: context,
                content: description,
                posX: this.width() * 0.5,
                posY: this.height() * 0.5,
                align: "center",
                fontStyle: "40px Hevetica"
            });
            (0, $7fee6969fa349124$export$b11bd9a0808bdc9)({
                context: context,
                content: restartText,
                posX: this.width() * 0.5,
                posY: this.height() * 0.95,
                align: "center",
                fontStyle: "30px Hevetica"
            });
            context.restore();
        }
    }
    /**
   * Reset all game state variables to their initial values
   */ restart() {
        this.obstacles = [];
        this.eggs = [];
        this.toads = [];
        this.hatchlings = [];
        this.eggTimer = 0;
        this.eggInterval = 1000;
        this.eggCountMax = 10;
        this.toadCountMax = 5;
        this.lostHatchlings = 0;
        this.score = 0;
        this.over = false;
        this.mouse = {
            posX: this.width() * 0.5,
            posY: this.height() * 0.5,
            pressed: false
        };
        this.player = new (0, $0017c5d798155445$export$2616165974278734)(this);
        this.topMargin = Math.floor(this.height() * 0.5);
        this.init();
    }
}


window.addEventListener("load", function() {
    const canvas = document.getElementById("game-canvas");
    const context = canvas.getContext("2d");
    canvas.width = 1280;
    canvas.height = 720;
    function resizeCanvasAndGame() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        if (game) {
            game.topMargin = Math.max(200, Math.floor(canvas.height * 0.18)); // adjust margin responsively
            if (typeof game.restart === "function") game.restart();
        }
        context.font = Math.floor(canvas.height * 0.04) + "px Helvetica";
    }
    let game;
    let lastTimeStamp = 0;
    function animate(timestamp) {
        const deltaTime = timestamp - lastTimeStamp;
        lastTimeStamp = timestamp;
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.fillStyle = "white";
        context.strokeStyle = "white";
        context.font = "40px Helvetica";
        context.textAlign = "center";
        if (game) game.render(context, deltaTime);
        window.requestAnimationFrame(animate);
    }
    function startGame() {
        game = new (0, $55b76b594f4baf04$export$985739bfa5723e08)(canvas);
        game.init();
        resizeCanvasAndGame();
        lastTimeStamp = 0;
        animate(0);
    }
    window.addEventListener("resize", resizeCanvasAndGame);
    startGame();
});


//# sourceMappingURL=index.b5bd9b12.js.map
